import { render, staticRenderFns } from "./section2.vue?vue&type=template&id=109556ca&scoped=true"
import script from "./section2.vue?vue&type=script&lang=js"
export * from "./section2.vue?vue&type=script&lang=js"
import style0 from "./section2.vue?vue&type=style&index=0&id=109556ca&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "109556ca",
  null
  
)

export default component.exports